import styles from "../../../../styles/patient-page-modules/readingModal.module.css";
import { formatDate, convertUTCToLocal } from "../../../../utils/helper";

export const bloodGlucoseColumns = [
  {
    key: "reading_dates",
    label: "Reading Dates",
    alignLeft: true,
    // SCRUM-989: the rows have no "reading_dates" field, so the sort arrows
    // need the date shown (date and time).
    sortField: "recorded_at",
    render: (reading) => convertUTCToLocal(reading.recorded_at),
  },
  {
    key: "glucose_level",
    label: "Glucose",
    render: (reading) => (
      <div className={styles.condition}>
        <div
          className={styles.condition_mark}
          style={{
            backgroundColor:
              reading.glucose < 120
                ? "green"
                : reading.glucose < 130
                ? "yellow"
                : "red",
            borderColor:
              reading.glucose < 120
                ? "greenyellow"
                : reading.glucose < 130
                ? "gold"
                : "orange",
          }}
        ></div>{" "}
        {reading.glucose} mg/dl
      </div>
    ),
  },
];
